import React from 'react';
import classNames from 'classnames';
import { Button } from '@johnlewispartnership/wtr-ingredients/ingredients/Button';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { ProductPodPromotions } from '@johnlewispartnership/wtr-ingredients/ingredients/ProductPodPromotions';
import type { Promotion } from '@johnlewispartnership/wtr-ingredients/ingredients/ProductPod/types';
import ShoppablePodStyles from '../../ProductGrid/ShoppablePod/index.scss';
import styles from './index.scss';
import { SwapProductPayload } from '../index';
import ProductBadges from '../../ProductGrid/ShoppablePod/ProductBadges';
import ProductDescription from '../../ProductGrid/ShoppablePod/ProductDescription';

interface SwapProductItemProps extends Omit<SwapProductPayload, 'promotions'> {
  promotions: Promotion[];
  onSelect?: () => void;
  hideSelectButton?: boolean;
  isCurrentSelection?: boolean;
}

export const SwapProductItem = ({
  id,
  name,
  size,
  isSponsored,
  isNewRecipe,
  isAllergenUpdate,
  thumbnail,
  productUrl,
  displayPrice,
  displayUOMPrice,
  promotions,
  currentSaleUnitPrice,
  onSelect,
  hideSelectButton = false,
  isCurrentSelection = false,
}: SwapProductItemProps) => {
  return (
    <div
      className={classNames(ShoppablePodStyles.pod, styles.pod, {
        [styles.productContainerCurrentSelection]: isCurrentSelection,
      })}
      data-testid="swap-product-item"
      key={`swap-product-item-${id}`}
    >
      <div className={classNames(ShoppablePodStyles.productInfo, styles.productInfo)}>
        <div className={ShoppablePodStyles.productMain}>
          <div className={ShoppablePodStyles.image}>
            <img src={thumbnail} alt={name} />
          </div>
          <div className={ShoppablePodStyles.details}>
            <ProductBadges
              isSponsored={isSponsored}
              isNewRecipe={isNewRecipe}
              isAllergenUpdate={isAllergenUpdate}
            />
            <ProductDescription name={name} size={size} productUrl={productUrl} />
            <ProductPodPromotions
              promotions={promotions ?? []}
              currentSaleUnitPrice={currentSaleUnitPrice}
              productId={id}
            />
          </div>
        </div>
      </div>
      <div className={styles.productPricing}>
        <div className={styles.productPricingText}>
          <Typography styleAs="paragraphHeading" textStyle="heading-l">
            {displayPrice}
          </Typography>
          {displayUOMPrice && (
            <Typography styleAs="paragraph" textStyle="body-m" data-testid="displayUOMPrice">
              {displayUOMPrice.replace(/[()]/g, '')}
            </Typography>
          )}
        </div>
        {!hideSelectButton && (
          <Button
            className={styles.selectButton}
            onClick={onSelect}
            data-testid="select-swap-product-item"
          >
            Select
          </Button>
        )}
      </div>
    </div>
  );
};
